/* eslint-disable */
import { Injectable } from '@angular/core';

export const dashboardChartFixedCellWidth = 185;
export const dashboardChartFixedCellHeight = 185;
export const dashboardChartMargin = 20;
export const dashboardColumnNumber = 4;

export const reportChartFixedCellWidth = 110;
export const reportChartFixedCellHeight = 110;
export const reportChartMargin = 20;

@Injectable()
export class ChartSizeHelper {

    // All these numbers are slightly bigger than the actual sizes due to scroll bar, border, etc.
    static readonly dashboardMinCellWidth = 181; // (dashboardMinWidth: 830 - scrollBarWidth: ~16 - dashboardChartMargin: 30 * (dashboardColumnNumber: 4 - 1)) / dashboardColumnNumber: 4
    static readonly dashboardMaxCellWidth = 279;

    static getMinWidthAtMinCanvas(): number {
        return this.getWidthAtMinCanvas(2, 1);
    }

    static getMinWidthAtMaxCanvas(): number {
        return this.getWidthAtMaxCanvas(2, 1);
    }

    static getCellHeight(): number {
        return this.getHeight(2, 1);
    }

    static getWidthAtMinCanvas(reportColNum: number, dbColNum: number): number {
        return Math.max(reportColNum * reportChartFixedCellWidth + (reportColNum - 1) * reportChartMargin, dbColNum * this.dashboardMinCellWidth + (dbColNum - 1) * dashboardChartMargin);
    }

    static getWidthAtMaxCanvas(reportColNum: number, dbColNum: number): number {
        return Math.max(reportColNum * reportChartFixedCellWidth + (reportColNum - 1) * reportChartMargin, dbColNum * this.dashboardMaxCellWidth + (dbColNum - 1) * dashboardChartMargin);
    }

    static getHeight(reportColNum: number, dbColNum: number): number {
        return Math.max(reportColNum * reportChartFixedCellHeight + (reportColNum - 1) * reportChartMargin, dbColNum * dashboardChartFixedCellHeight + (dbColNum - 1) * dashboardChartMargin);
    }

    static getChartGridWidth(columnCount: number) {
        return columnCount * reportChartFixedCellWidth + (columnCount - 1) * reportChartMargin;
    }

    static getChartGridHeight(rowCount: number) {
        return rowCount * reportChartFixedCellWidth + (rowCount - 1) * reportChartMargin;
    }
}
